import BasicDetails from "pages/Dashboard/UserProfileDetails/BasicDetails";
import { UserStruct, UserTypes } from "../../api/auth"
import { ChatsActionTypes } from "../chats/types"
import { CurUser, Utils } from "helpers/utils";
import { DbScope } from "helpers/dbScope";
import { Const } from "const";
export enum Profile2ActionTypes {
    // API_RESPONSE_SUCCESS = "@@profile2/API_RESPONSE_SUCCESS",
    // API_RESPONSE_ERROR = "@@profile2/API_RESPONSE_ERROR",

    // GET_PROFILE_DETAILS = "@@profile2/GET_PROFILE_DETAILS",

    SET_USER = "@@profile2/SET_USER",
    SET_USER_DONE = "@@profile2/SET_USER_DONE",

    CLEAR_USER = "@@profile2/CLEAR_USER",
    CLEAR_USER_DONE = "@@profile2/CLEAR_USER_DONE",
    SET_ACTIVE_GROUP_ID = "@@profile2/SET_ACTIVE_GROUP_ID",
    SET_ACTIVE_WEB_USER_ID = "@@profile2/SET_ACTIVE_WEB_USER_ID",
    SET_GROUP_INVITE_CODE = "@@profile2/SET_GROUP_INVITE_CODE",

    GET_CURRENT_USER = "@@profile2/GET_CURRENT_USER",
    UPDATE_READ_MSG = "@@profile2/UPDATE_READ_MSG",

    GET_PUSH_HISTORY_LOCAL = "@@pushhist_get",
    DEL_PUSH_HISTORY_LOCAL = "@@pushhist_clear",

    DEL_GROUP_FROM_USER = "@@profile2/DEL_GROUP_FROM_USER",
    APPLY_USER_TO_GROUP = "@@profile2/APPLY_USER_TO_GROUP",
    SET_USER_GROUPS = "@@profile2/SET_USER_GROUPS",

    SET_FAKE_SMS_MODE = "@@profile2/SET_FAKE_SMS_MODE",
    FIND_MEMBER_TO_GROUP = "@@profile2/FIND_MEMBER_TO_GROUP",
    FIND_DCONNECT_WEB_USER = "@@profile2/FIND_DCONNECT_WEB_USER",
    FIND_DCONNECT_CUS_FORMATCH = "@@profile2/FIND_DCONNECT_CUS_FORMATCH",
    FIND_EPR_SUP_FORMATCH = "@@profile2/FIND_EPR_SUP_FORMATCH",

    UC_CHAT_ALIGH_RIGHT = "@@profile2/UC_CHAT_ALIGH_RIGHT",

    SET_VIEW_AS = "@@chats/SET_VIEW_AS",
}



// export interface Profile2State {
//     profile: any
// }

const fnLoadDefault = () => {
    // console.log('loadDefaultAuthUser');
    // const user = localStorage.getItem("authUser");
    const user = CurUser.GetAuthUserFromLocal();
    if (!user) {
        return {};
    } else {
        const json = JSON.parse(user);
        json.online = false;
        return json as UserStruct;
    }
}

export const INIT_STATE: UserStruct = fnLoadDefault();
// export const INIT_STATE: UserStruct = {
//     mobileNo: "",
//     userId: -1,
//     userType: UserTypes.Customer,
//     isAdmin: false,
//     firstName: "",
//     lastName: "",
//     fullName: "",
//     nickName: "",
//     companyName: "",
//     pictureUrl: ""
// };

const fnSetUser = (state: any, data: any, callFrom: string) => {
     //console.log('fnSetUser:', data);
    const fullName = (data.firstName || data.lastName) ? ([data.firstName, data.lastName].join(" ").trim()) : data.nickName;
    const firstName = data.firstName ? data.firstName : data.nickName;
    if (data.isViewAs) {
        localStorage.setItem("isViewAs", data.isViewAs);
        // localStorage.setItem("fnSetuserFrom" + Utils.GetCurrentDateTimeLongFormat(), callFrom);
    } else {
        localStorage.removeItem("isViewAs");
    }
    // console.log({fullName});
    localStorage.setItem("allowchat", data.isAllowChat);
    localStorage.setItem("allowchatsup", data.isAllowChatSup);
    DbScope.set(data.isViewAs ? null : data.userId); // 20261020: local cache per user; no cache in View-As mode
    return {
        ...state,
        mobileNo: data.authMobileNo,
        userId: data.userId,
        userType: data.userType,
        isAdmin: data.isAdmin,
        firstName: firstName,
        lastName: data.lastName,
        fullName: fullName,
        nickName: data.nickName,
        companyName: data.companyName,
        pictureUrl: data.pictureUrl,
        lastLogonDate: data.lastLogonDate,
        basicDetails: Utils.Profile2ToProfileBasicDetail(data),
        groups: data.groups,
        groupInviteCode: data.groupInviteCode,
        extUserId: data.extUserId,
        extUserSystem: data.extUserSystem,
        serverConfig: data.serverConfig,
        chatAlighRight: data.chatAlignRight,
        displayName: data.displayName,
        isDev: data.isDev,
        isViewAs: data.isViewAs,
        viewAsUserId: data.viewAsUserId,
        viewAsUserName: data.viewAsUserName,
        isAllowChat: data.isAllowChat,
        isAllowChatSup: data.isAllowChatSup,
        isItSupport: data.isItSupport,
    };
}

const fnClearUser = (state: any) => {
    //console.log('const fnClearUser = (state: any) => {');
    localStorage.removeItem("isViewAs");
    return {
        ...state,
        mobileNo: INIT_STATE.mobileNo,
        userId: INIT_STATE.userId,
        userType: INIT_STATE.userType,
        isAdmin: INIT_STATE.isAdmin,
        firstName: INIT_STATE.firstName,
        lastName: INIT_STATE.lastName,
        fullName: INIT_STATE.fullName,
        nickName: INIT_STATE.nickName,
        companyName: INIT_STATE.companyName,
        pictureUrl: INIT_STATE.pictureUrl,
        lastLogonDate: null,
        basicDetails: null,
        groups: [],
        groupInviteCode: null,
        extUserId: null,
        extUserSystem: null,
        serverConfig: null,
        chatAlighRight: Const.UC_CHAT_ALIGH_RIGHT_COMP,
        displayName: null,
        isDev: false,
        isViewAs: false,
        viewAsUserId: null,
        viewAsUserName: null,
        isAllowChat: localStorage.getItem("allowchat") ?? true,
        isAllowChatSup: localStorage.getItem("allowchatsup") ?? false, // 20250915
        isItSupport: false,
    };
}

const Profile2 = (state = INIT_STATE, action: any) => {
    // console.log('Reducer.Profile2=' + action.type + '.' + (action.payload ? action.payload.actionType : ''));
    if (action.type == ChatsActionTypes.API_RESPONSE_SUCCESS) {
        switch (action.payload.actionType) {
            case Profile2ActionTypes.GET_CURRENT_USER:
                // console.log('API_RESPONSE_SUCCESS.GET_CURRENT_USER', action.payload.data);
                if (action.payload.data.success) {
                    return fnSetUser(state, action.payload.data.data, "API Success");
                } else {
                    return fnClearUser(state);
                }
            case Profile2ActionTypes.DEL_GROUP_FROM_USER:
                return {
                    ...state,
                    groups: action.payload.data
                }
            case Profile2ActionTypes.APPLY_USER_TO_GROUP:
                return {
                    ...state,
                    groups: action.payload.data
                }
            case Profile2ActionTypes.FIND_MEMBER_TO_GROUP:
                const filterUserType = action.payload.data.filterUserType;
                if (filterUserType == UserTypes.Customer || filterUserType == UserTypes.Supplier) {
                    return {
                        ...state,
                        findMemberCus: action.payload.data.response,
                        findMemberOn: false
                    }
                } else {
                    return {
                        ...state,
                        findMember: action.payload.data.response,
                        findMemberOn: false
                    }
                }
            case Profile2ActionTypes.FIND_DCONNECT_WEB_USER:
                return {
                    ...state,
                    findDConnectUsers: action.payload.data,
                    findDConnectUserOn: false
                }
            case Profile2ActionTypes.FIND_DCONNECT_CUS_FORMATCH:
                return {
                    ...state,
                    findDConnectCust: action.payload.data,
                    findDConnectCustOn: false
                }
            case Profile2ActionTypes.FIND_EPR_SUP_FORMATCH:
                return {
                    ...state,
                    findErpSup: action.payload.data,
                    findErpSupOn: false
                }

        }
    }
    if (action.type == ChatsActionTypes.API_RESPONSE_ERROR) {
        switch (action.payload.actionType) {
            case Profile2ActionTypes.GET_CURRENT_USER:
                // console.log('API_RESPONSE_ERROR.GET_CURRENT_USER', action.payload);
                return fnClearUser(state);
        }
    }

    switch (action.type) {
        case Profile2ActionTypes.SET_USER_DONE:
            //console.log('Profile2ActionTypes.SET_USER_DONE  = ' + action);
            return fnSetUser(state, action.payload, "Set user done");
        case Profile2ActionTypes.CLEAR_USER_DONE:
            //console.log('Profile2ActionTypes. ' + action.type);
            return {
                ...state,
                mobileNo: INIT_STATE.mobileNo,
                // userId: INIT_STATE.userId,
                userId: null, // 20250702
                userType: INIT_STATE.userType,
                isAdmin: INIT_STATE.isAdmin,
                firstName: INIT_STATE.firstName,
                lastName: INIT_STATE.lastName,
                fullName: INIT_STATE.fullName,
                nickName: INIT_STATE.nickName,
                companyName: INIT_STATE.companyName,
                pictureUrl: INIT_STATE.pictureUrl,
                lastLogonDate: null
            };
        case Profile2ActionTypes.SET_USER_GROUPS:
            //console.log('case Profile2ActionTypes.SET_USER_GROUPS::', action);
            return {
                ...state,
                groups: action.payload
            }
        case Profile2ActionTypes.FIND_MEMBER_TO_GROUP:
            //console.log('Profile2ActionTypes.FIND_MEMBER_TO_GROUP:', action.payload);
            if (action.payload.filterUserType == UserTypes.Employee) {
                return {
                    ...state,
                    findMemberOn: true,
                    findMemberFilter: action.payload.filters,
                    findMemberFilterUserType: action.payload.filterUserType
                }
            } else {
                return {
                    ...state,
                    findMemberOn: true,
                    findMemberCusFilter: action.payload.filters,
                    findMemberFilterUserType: action.payload.filterUserType
                }
            }
        case Profile2ActionTypes.FIND_DCONNECT_WEB_USER:
            return {
                ...state,
                findDConnectUserOn: true
            }

        case Profile2ActionTypes.FIND_DCONNECT_CUS_FORMATCH:
            return {
                ...state,
                findDConnectCustOn: true
            }
        case Profile2ActionTypes.FIND_EPR_SUP_FORMATCH:
            return {
                ...state,
                findErpSupOn: true
            }

        case Profile2ActionTypes.SET_ACTIVE_GROUP_ID:
            //console.log('Profile2ActionTypes.SET_ACTIVE_GROUP_ID : ' + action.payload);
            return {
                ...state,
                activeGroupId: action.payload
            };
        case Profile2ActionTypes.SET_ACTIVE_WEB_USER_ID:
            // console.log('Profile2ActionTypes.SET_ACTIVE_WEB_USER_ID:' , action);
            return {
                ...state,
                webUserId: action.payload.webUserId,
                customerIsCdSys: action.payload.customerIsCdSys,
            };

        case Profile2ActionTypes.SET_FAKE_SMS_MODE:
            return {
                ...state,
                isFakeSms: action.payload
            }
        case Profile2ActionTypes.SET_GROUP_INVITE_CODE:
            // console.log('Profile2ActionTypes. ' + action.type);
            return {
                ...state,
                groupInviteCode: action.payload
            };
        case Profile2ActionTypes.GET_PUSH_HISTORY_LOCAL:
            // console.log('Profile2ActionTypes.GET_PUSH_HISTORY_LOCAL:', action.payload);
            return {
                ...state,
            };

        case ChatsActionTypes.ADD_USER_TO_GROUP: {
            const { groupId, memberId, isAdd } = action.payload;
            return {
                ...state,
                findMember: (state as any).findMember.map((member: any) =>
                    member.userId == memberId
                        ? { ...member, isAlreadyMember: isAdd } // Toggle isAlreadyMember
                        : member // Leave other members unchanged
                ),
            }
        }

        case Profile2ActionTypes.UC_CHAT_ALIGH_RIGHT: {
            const { chatAlighRight } = action.payload;
            // console.log('Profile2ActionTypes.UC_CHAT_ALIGH_RIGHT:', chatAlighRight);
            return {
                ...state,
                chatAlighRight: chatAlighRight
            }
        }


        default:
            return { ...state };
    }
};

export default Profile2;


// actions
// export const setCurrentUser = (data: UserStruct) => ({
//     type: Profile2ActionTypes.SET_USER,
//     payload: data
// });

export const setCurrentUser = (data: UserStruct) => {
    // Utils.sleep(5000);
    return {
        type: Profile2ActionTypes.SET_USER,
        payload: { data }
    }
};

export const setCurrentUserDone = (data: UserStruct) => ({
    type: Profile2ActionTypes.SET_USER_DONE,
    payload: data
})

export const clearCurrentUser = (callFrom: string, reason: string) => ({
    type: Profile2ActionTypes.CLEAR_USER,
    payload: { callFrom, reason },
});

export const clearCurrentUserDone = () => ({
    type: Profile2ActionTypes.CLEAR_USER_DONE,
});

export const setActiveGroupId = (groupId: number) => ({
    type: Profile2ActionTypes.SET_ACTIVE_GROUP_ID,
    payload: groupId
});

export const setActiveWebUserId = (webUserId: any, customerIsCdSys: any) => ({
    type: Profile2ActionTypes.SET_ACTIVE_WEB_USER_ID,
    payload: { webUserId, customerIsCdSys }
});

export const setIsFakeSmsMode = (isFakeSmsMode: boolean) => ({
    type: Profile2ActionTypes.SET_FAKE_SMS_MODE,
    payload: isFakeSmsMode
});

export const findMemberToGroup = (currentGroupId: any, filters: string, filterUserType: any) => ({
    type: Profile2ActionTypes.FIND_MEMBER_TO_GROUP,
    payload: { currentGroupId: currentGroupId, filters: filters, filterUserType: filterUserType }
});

export const findDconnectWebUser = (groupChatId: any, filters: string) => ({
    type: Profile2ActionTypes.FIND_DCONNECT_WEB_USER,
    payload: { groupChatId: groupChatId, filters: filters }
});

export const findDConnectCusForMatch = (customerCode: string, customerName: string) => ({
    type: Profile2ActionTypes.FIND_DCONNECT_CUS_FORMATCH,
    payload: { customerCode, customerName }
});

export const findErpSupForMatch = (supplierCode: string, supplierName: string) => ({
    type: Profile2ActionTypes.FIND_EPR_SUP_FORMATCH,
    payload: { supplierCode, supplierName }
});

export const setGroupInviteCode = (code: string) => ({
    type: Profile2ActionTypes.SET_GROUP_INVITE_CODE,
    payload: code
});

export const getCurrentUserAction = () => ({
    type: Profile2ActionTypes.GET_CURRENT_USER
})

export const updateReadMsg = (userGroupId: number, msgIds: []) => ({
    type: Profile2ActionTypes.UPDATE_READ_MSG,
    payload: { userGroupId, msgIds }
});

export const getPushHistoryLocal = (msgs: any) => ({
    type: Profile2ActionTypes.GET_PUSH_HISTORY_LOCAL,
    payload: msgs
});


export const delGroupFromUser = (groupId: number, memberId: number) => ({
    type: Profile2ActionTypes.DEL_GROUP_FROM_USER,
    payload: { groupId, memberId }
})

export const applyUserToGroup = (groupId: number, memberId: number, inviteCode: string) => ({
    type: Profile2ActionTypes.APPLY_USER_TO_GROUP,
    payload: { groupId, memberId, inviteCode }
})

export const setUserGroups = (groups: any) => ({
    type: Profile2ActionTypes.SET_USER_GROUPS,
    payload: groups
})

export const ucChatAlighRight = (chatAlighRight: any) => ({
    type: Profile2ActionTypes.UC_CHAT_ALIGH_RIGHT,
    payload: { chatAlighRight }
})

export const setViewAs = (isViewAs: boolean, viewAsUserId?: number | null, viewAsUserName?: string | null) => ({
    type: Profile2ActionTypes.SET_VIEW_AS,
    payload: { isViewAs, viewAsUserId, viewAsUserName }
})